import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ActionsAddFilterIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M10.475 23.649c-.828-.001-1.5-.672-1.501-1.5V12.87C4.041 11.591.37 7.208.004 2.108.002 2.071 0 2.038 0 2.005c0-.4.156-.777.439-1.061.283-.283.66-.44 1.061-.44h20.952c.432-.001.843.185 1.127.511.264.301.396.687.37 1.088l-.001.01c-.369 5.099-4.041 9.481-8.974 10.757v6.779c.001.447-.197.867-.541 1.153l-2.999 2.499c-.27.224-.609.348-.959.348zM1.501 2.004c.347 4.679 3.787 8.598 8.373 9.535.348.071.6.38.6.735v9.875l3-2.5v-7.375c0-.355.252-.664.6-.735 4.596-.937 8.041-4.859 8.378-9.537l-20.951.002z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ActionsAddFilterIcon = __decorateClass([
  customElement("elm-actions-add-filter-icon")
], ActionsAddFilterIcon);
export { ActionsAddFilterIcon };
